export enum StatementStatusEnum {
  ACTIVE = 'active',
  CANCELED = 'canceled',
  EXPIRED = 'expired',
}

export const StatementStatusMap = new Map<string, string>();
StatementStatusMap.set('active', 'Ativo');
StatementStatusMap.set('canceled', 'Cancelado');
StatementStatusMap.set('expired', 'Expirado');


export enum StatementTypeEnum {
  INCOME = 'income',
  EXPENSE = 'expense',
}

export  const StatementTypeMap = new Map<string, string>();
StatementTypeMap.set('income', 'Crédito Gerado');
StatementTypeMap.set('expense', 'Resgate');
StatementTypeMap.set('expired', 'Crédito Expirado');

export default interface CashbackStatement {
  id: number | "";
  store_id: number | "";
  customer_id: number | "";
  cashback_id: number | "";
  recovery_id: number | "";
  value: number | "";
  status: StatementStatusEnum;
  type: StatementTypeEnum;
  expiration_date: "";
  manually: boolean;
  description: string;
  created_at: string | "";
  updated_at: string | "";
}
